module.exports = __webpack_public_path__ + "fonts/Amaranth-Bold.90cf1c8b.eot";